// extracted by mini-css-extract-plugin
export default {"msg":"ConfirmModal_msg__wDfLq","btnPrimary":"ConfirmModal_btnPrimary__50Tna","btnGhost":"ConfirmModal_btnGhost__cqovl","btnDanger":"ConfirmModal_btnDanger__RvOQx"};